/*class QuickAdd{clearForms(){var t=theme.off_canvas.right_sidebar.querySelectorAll(".product--form");t.length&&t.forEach(t=>t.remove())}initForm(t){var e,a=theme.off_canvas["right_sidebar"],r=a.querySelectorAll(".product--form"),o=(r.length&&r.forEach(t=>t.style.display="none"),t.dataset)["handle"],d=a.querySelector(`[data-handle='${o}']`);theme.utils.updateRecentProducts(o),d?d.style.display="block":(e=t.closest(".product--root").querySelector(".product--form"),document.querySelector('[data-view="product-form"]').appendChild(e))}async addToCart(t){t.setAttribute("data-loading",!0);var e,a=t.closest(".product--root").querySelector(".product-buy-buttons--form");theme.utils.getAvailableQuantity(a)?(e=await theme.cart.addItem(a),t.setAttribute("data-loading",!1),e&&(await theme.cart.updateAllHtml(),"closed"===theme.off_canvas.state)&&theme.off_canvas.openRight()):t.setAttribute("data-loading",!1),window.trigger("resize")}}theme.quick_add=new QuickAdd;*/
class QuickAdd {
    clearForms() {
        var t = theme.off_canvas.right_sidebar.querySelectorAll(".product--form");
        t.length && t.forEach((t) => t.remove());
    }
    initForm(t) {
        var e,
            a = theme.off_canvas["right_sidebar"],
            r = a.querySelectorAll(".product--form"),
            o = (r.length && r.forEach((t) => (t.style.display = "none")), t.dataset)["handle"],
            d = a.querySelector(`[data-handle='${o}']`);
        theme.utils.updateRecentProducts(o), d ? (d.style.display = "block") : ((e = t.closest(".product--root").querySelector(".product--form")), document.querySelector('[data-view="product-form"]').appendChild(e));
    }
    async addToCart(t) {
        t.setAttribute("data-loading", !0);
        var e,
            a = t.closest(".product--root").querySelector(".product-buy-buttons--form");
        theme.utils.getAvailableQuantity(a)
            ? ((e = await theme.cart.addItem(a)), t.setAttribute("data-loading", !1), e && (await theme.cart.updateAllHtml(), "closed" === theme.off_canvas.state) && theme.off_canvas.openRight())
            : t.setAttribute("data-loading", !1),
            window.trigger("resize");
    }

}
theme.quick_add = new QuickAdd();
